import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "calculator__branches"
}
const _hoisted_2 = {
  key: 1,
  class: "calculator__branches--mobile"
}
const _hoisted_3 = { class: "custom-branch-option" }
const _hoisted_4 = ["src", "alt"]

import BaseCalculatorBranchIcon from '@/components/BaseCalculator/BaseCalculatorBranchIcon.vue';
import SelectField from '@/components/SelectField.vue';
import BranchInterface from '@/interfaces/BranchInterface';
import { computed, inject, Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCalculatorBranchSelection',
  props: /*#__PURE__*/_mergeModels({
    allowedBranches: { default: () => ([]) }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const branch = _useModel<BranchInterface | undefined>(__props, "modelValue");

const props = __props;

const isMobileBreakpoint = inject('isMobileBreakpoint') as Ref<boolean>;

const allowedBranchesOptions = computed(() => [...props.allowedBranches].map((allowedBranch: BranchInterface) => ({
  value: allowedBranch.slug,
  label: allowedBranch.name,
})));

const getOptionImageUrl = (branchSlug: string): string | undefined => props.allowedBranches.find((allowedBranch) => allowedBranch.slug === branchSlug)?.image?.url;

const onSelectBranch = (branchOption: BranchInterface | string) => {
  let selectedBranchOption = branchOption;

  if (typeof selectedBranchOption === 'string') {
    selectedBranchOption = [...props.allowedBranches].find((allowedBranch) => allowedBranch.slug === selectedBranchOption);
  }

  if (branch.value?.slug === selectedBranchOption.slug) {
    branch.value = undefined;

    return;
  }

  branch.value = { ...selectedBranchOption };
};

return (_ctx: any,_cache: any) => {
  return (!_unref(isMobileBreakpoint) && _ctx.allowedBranches.length > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allowedBranches, (branchOption) => {
          return (_openBlock(), _createBlock(BaseCalculatorBranchIcon, {
            key: `branch-option-${branchOption.slug}`,
            branch: branchOption,
            selected: branchOption.slug === branch.value?.slug,
            deselected: !!branch.value?.slug && branch.value.slug !== branchOption.slug,
            onClick: _withModifiers(($event: any) => (onSelectBranch(branchOption)), ["prevent"])
          }, null, 8, ["branch", "selected", "deselected", "onClick"]))
        }), 128))
      ]))
    : (_ctx.allowedBranches.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(SelectField, {
            label: "Produkt auswählen",
            "custom-list-class": "custom-branch-list",
            options: allowedBranchesOptions.value,
            "model-value": branch.value?.slug,
            "icon-left": getOptionImageUrl(branch.value?.slug),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (onSelectBranch($event))),
            "position-absolute": ""
          }, {
            option: _withCtx(({ option }) => [
              _createElementVNode("span", _hoisted_3, [
                _createElementVNode("span", null, [
                  _createElementVNode("img", {
                    src: getOptionImageUrl(option.value),
                    alt: `Icon ${option.label}`
                  }, null, 8, _hoisted_4)
                ]),
                _createElementVNode("span", null, _toDisplayString(option.label), 1)
              ])
            ]),
            _: 1
          }, 8, ["options", "model-value", "icon-left"])
        ]))
      : _createCommentVNode("", true)
}
}

})